/* eslint-disable no-param-reassign */

// In config, first level keys should be named after the routes names
// in order to use the shorten $content computed property
const config = require('./config.json');
const collections = require('./collections.json');
const products = require('./coins.json');

// MDP Tools require the products to be on the first route to generate the correspondig HTML
config.routes = [{ id: 'dc', products }];
config.collections = collections;
module.exports = config;
